/** Shared flex layout for wizard footer action buttons (Figma — campaign setup + instrument flows). */
export const WIZARD_ACTION_BUTTON_LAYOUT_SX = {
  display: 'flex',
  height: '40px',
  padding: '12px 16px',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
} as const

/** Text Cancel — same as create-campaign step 1 (`CampaignSetupPage`). */
export const WIZARD_CANCEL_TEXT_BUTTON_SX = {
  ...WIZARD_ACTION_BUTTON_LAYOUT_SX,
  color: '#4a5565',
} as const
